import { render } from "./SwitchThemeMessage.vue?vue&type=template&id=9978a122&scoped=true"
import script from "./SwitchThemeMessage.vue?vue&type=script&lang=js"
export * from "./SwitchThemeMessage.vue?vue&type=script&lang=js"

import "./SwitchThemeMessage.vue?vue&type=style&index=0&id=9978a122&lang=scss&scoped=true"
import "./SwitchThemeMessage.vue?vue&type=style&index=1&id=9978a122&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9978a122"]])

export default __exports__